import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpscreentruth15postPostScreenTruthDecisionsResponseSchema = jsonObject
export type tcpscreentruth15postPostScreenTruthDecisionsResponse = z.infer<typeof tcpscreentruth15postPostScreenTruthDecisionsResponseSchema>
export const tcpscreentruth15postPostScreenTruthProposalsResponseSchema = jsonObject
export type tcpscreentruth15postPostScreenTruthProposalsResponse = z.infer<typeof tcpscreentruth15postPostScreenTruthProposalsResponseSchema>
